/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ username: NonNullable<unknown> }} User_Archive_ConfirmInputs */

const en_user_archive_confirm = /** @type {(inputs: User_Archive_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Archive user "${i?.username}"?`)
};

const ja_user_archive_confirm = /** @type {(inputs: User_Archive_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ユーザー "${i?.username}" をアーカイブしますか？`)
};

const fr_user_archive_confirm = /** @type {(inputs: User_Archive_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Archiver l'utilisateur "${i?.username}" ?`)
};

const de_user_archive_confirm = /** @type {(inputs: User_Archive_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Benutzer "${i?.username}" archivieren?`)
};

/**
* | output |
* | --- |
* | "Archive user \"{username}\"?" |
*
* @param {User_Archive_ConfirmInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_archive_confirm = /** @type {((inputs: User_Archive_ConfirmInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Archive_ConfirmInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_archive_confirm(inputs)
	if (locale === "ja") return ja_user_archive_confirm(inputs)
	if (locale === "fr") return fr_user_archive_confirm(inputs)
	return de_user_archive_confirm(inputs)
});